import { useEffect, useState } from 'react';

import { SalePayload } from '../types';
import { fetchSale } from '../services/saleService';

export const useSale = () => {
  const [sale, setSale] = useState<SalePayload | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadSale = async () => {
      try {
        const saleData = await fetchSale();
        if (isMounted) {
          setSale(saleData);
        }
      } catch (error) {
        console.error('Failed to load sale content', error);
      }
    };

    loadSale();

    return () => {
      isMounted = false;
    };
  }, []);

  return { sale };
};

